import toast from "react-hot-toast";
import * as api from "../Api";
import { message } from "antd";

// create a  new asset
export const getCompanyAsset = () => async (dispatch) => {
  let fetchingId;
  try {
    toast.dismiss();
    fetchingId = toast.loading("Loading System Data....");
    const { data } = await api.fetchAssets();
    dispatch({ type: "FETCH_ALL_ASSET", payload: data });
    toast.dismiss();
    toast.remove(fetchingId);
    message.info("System Data Successfully Loaded");
  } catch (error) {
    toast.error(error.message);
  }
};

export const createCompanyAsset = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting asset for approval....");
    const { data } = await api.createAsset(postData);
    dispatch({ type: "CREATE_ASSET", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
